import { Component, AfterViewInit, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Player from '@vimeo/player';
import { ReplaySubject } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';

export enum KEY_CODE {
  RIGHT_ARROW = 'ArrowRight',
  LEFT_ARROW = 'ArrowLeft',
}

export interface NavigationModalData {
  modalTitle: string;
  src?: string;
  subtitle?: string;
}

const DEFAULT_VIDEO_SRC =
  'https://player.vimeo.com/video/673272653?h=66b413854f&badge=0&amp;autoplay=1&amp;autopause=0&amp;player_id=0&amp;app_id=58479';

@Component({
  selector: 'app-navigation-modal',
  templateUrl: './navigation-modal.component.html',
  styleUrls: ['./navigation-modal.component.scss'],
  standalone: false,
})
export class NavigationModalComponent extends Loggable implements AfterViewInit, OnDestroy {
  protected data = inject<NavigationModalData>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<NavigationModalComponent>>(MatDialogRef);

  public get subtitle(): string {
    if (this.data.subtitle) {
      return this.data.subtitle;
    }

    return "Here's a quick video on how to use Scoot";
  }
  public buttonText = 'Skip';
  public videoSrc = DEFAULT_VIDEO_SRC;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor() {
    super();
    const data = this.data;

    this.setDisplayName('NavigationModalComponent');
    if (data.src) {
      this.videoSrc = data.src;
    }
  }

  private videoEnded(): void {
    this.buttonText = 'Next';
  }

  public ngAfterViewInit(): void {
    const iframe = document.getElementById('demoFlowIframe');
    if (!iframe) {
      this.error('iframe not found: demoFlowIframe');
      return;
    }
    const player = new Player(iframe);
    player.on('ended', () => {
      this.videoEnded();
    });
  }

  public btnClicked(): void {
    this.dialogRef.close(false);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
